import { render, staticRenderFns } from "./InnerNewsPage.vue?vue&type=template&id=4a89eea4&"
import script from "./InnerNewsPage.vue?vue&type=script&lang=js&"
export * from "./InnerNewsPage.vue?vue&type=script&lang=js&"
import style0 from "./InnerNewsPage.vue?vue&type=style&index=0&id=4a89eea4&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a89eea4')) {
      api.createRecord('4a89eea4', component.options)
    } else {
      api.reload('4a89eea4', component.options)
    }
    module.hot.accept("./InnerNewsPage.vue?vue&type=template&id=4a89eea4&", function () {
      api.rerender('4a89eea4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/InnerNewsPage.vue"
export default component.exports